import React from 'react';

const Orb = ({ hoverIntensity = 0.3, rotateOnHover = true, hue = 280, forceHoverState = false }) => {
  return (
    <div style={{
      position: 'absolute',
      width: '100%',
      height: '100%',
      background: `radial-gradient(circle at 50% 50%, hsla(${hue}, 100%, 50%, ${hoverIntensity}), transparent 70%)`,
      filter: 'blur(100px)',
      animation: rotateOnHover ? 'orbRotate 20s linear infinite' : 'none',
      pointerEvents: 'none'
    }}>
      <style>{`
        @keyframes orbRotate {
          0% { transform: rotate(0deg) scale(1); }
          50% { transform: rotate(180deg) scale(1.1); }
          100% { transform: rotate(360deg) scale(1); }
        }
      `}</style>
    </div>
  );
};

export default Orb;
